<template>
  <div>
      <v-row>
          <v-col cols="12" sm="12">
              <v-card>
                    <br>
                    <div class="mx-4" style="border:1px solid #ffeeee;border-radius:10px">
                        <div class="ml-4">
                            <br>
                            <div>Tanggal diiklankan : {{iklan.created_at | dateTimeFormat}} WIB</div>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-carousel
                                        v-model="carousel"
                                        hide-delimiters
                                        hide-delimiter-background
                                        show-arrows
                                        show-arrows-on-hover
                                        height="200"
                                    >
                                        <v-carousel-item
                                        v-for="(item, index) in fotos"
                                        :key="index"
                                        :src="$url_img + item.src"
                                        reverse-transition="fade-transition"
                                        transition="fade-transition"
                                        >
                                        </v-carousel-item>
                                    </v-carousel>
                                    <div class="d-flex justify-space-between mt-2">
                                        <v-card
                                        rounded="lg"
                                        hover
                                        v-for="(item, index) in fotos"
                                        :key="index"
                                        @click="carousel = index"
                                        >
                                        <v-img :src="$url_img + item.src" width="50" height="50"></v-img>
                                        </v-card>
                                    </div>
                                </v-col>
                                <v-col cols="12" sm="8">
                                    <div>
                                        <h2>{{ iklan.judul }}</h2>
                                        <div>
                                            {{iklan.mst_iklan_jenis}} <v-icon>mdi-circle-small</v-icon>
                                            ID Iklan : {{ iklan.id }} <v-icon>mdi-circle-small</v-icon>
                                            <v-icon>mdi-eye</v-icon> {{ iklan.log_iklan_view }}x
                                        </div>
                                        <h2>
                                            Rp {{ Number(iklan.harga).toLocaleString('id-ID') }}
                                        </h2>
                                        <h3>Deskripsi</h3>
                                        <div v-if="selengkapnya == false" class="text-justify" style="white-space: pre-wrap"> {{ iklan.deskripsi.substring(0, 120) }} ... <span class="teal--text" @click="selengkapnya = true" style="cursor:pointer">Selengkapnya</span> </div>
                                        <div v-if="selengkapnya == true" class="text-justify" style="white-space: pre-wrap"> {{ iklan.deskripsi }} ... <span class="teal--text" @click="selengkapnya = false" style="cursor:pointer">Urungkan</span></div>
                                        <v-divider class="mt-2"></v-divider>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-divider class="mt-2"></v-divider>
                            <ListReportIklan :idIklan="idIklan"/>
                        </div>
                    </div>
                    <br>
              </v-card>
          </v-col>
      </v-row>
  </div>
</template>

<script>
import ListReportIklan from '@/components/ListReportIklan.vue';
import moment from 'moment';
export default {
    components: {
        ListReportIklan,
    },
    props: ['idIklan'],
    name: 'iklan-baris-pantau',
    data: () => ({
        iklan:[],
        fotos:[],
        detailMokas:[],
        selengkapnya:false,
        carousel: 0,
    }),
    methods: {
        async getHP() {
            await this.$req
                .get(this.$root.$baseapi.iklan+'/iklan/v3/iklan_hp_mokas', {
                params: {
                    id: this.idIklan,
                },
                })
                .then((response) => {
                    let { data } = response.data
                    this.iklan = data
                    this.getUnitMotorBekas(this.iklan.motor_bekas[0].id_motor_bekas)
                    console.log('iklan',this.iklan)
                })
                .catch((error) => {
                let responses = error.response.data
                console.log(responses.api_message)
                })
        },
        async getUnitMotorBekas(id){
            this.$req
                .get(this.$root.$baseapi.produk+'/produk/v3/unit_mokas_iklan', {
                params: {
                    id: id,
                    // search: this.$route.params.id,
                    limit: 1,
                },
                })
                .then((response) => {
                    this.detailMokas = response.data.data[0]
                    this.fotos = []
                    if (this.detailMokas.foto_1 != null) {
                        this.fotos.push({ src: this.detailMokas.foto_1 })
                    }
                    if (this.detailMokas.foto_2 != null) {
                        this.fotos.push({ src: this.detailMokas.foto_2 })
                    }
                    if (this.detailMokas.foto_3 != null) {
                        this.fotos.push({ src: this.detailMokas.foto_3 })
                    }
                    if (this.detailMokas.foto_4 != null) {
                        this.fotos.push({ src: this.detailMokas.foto_4 })
                    }
                    if (this.detailMokas.foto_5 != null) {
                        this.fotos.push({ src: this.detailMokas.foto_5 })
                    }
                    console.log('ini mokas', this.detailMokas)
                })
                .catch((error) => {
                let responses = error.response.data
                console.log(responses.api_message)
                })
        },
    },
    async created(){
        this.getHP()
    },
    filters: {
        countDoc(doc) {
        if (doc !== null) {
            return true;
        }
        },
        datediff: date => {
        return moment(date).from();
        },
        dateFormat: date => {
        return moment.utc(date).format('DD MMM YYYY');
        },
        timeFormat: date => {
        return moment.utc(date).format('HH:mm');
        },
        dateTimeFormat: date => {
        return moment.utc(date).format('DD MMM YYYY HH:mm');
        }
    },
}
</script>

<style>

</style>